import React from 'react';
import { AlertTriangle } from 'lucide-react';

export function ConfirmModal({ open, title, message, confirmLabel = 'Aceptar', cancelLabel = 'Cancelar', onConfirm, onCancel, variant = 'default' }) {
  if (!open) return null;
  const btnColor = variant === 'danger' ? 'bg-red-500 hover:bg-red-600' : 'bg-[#1B919B] hover:bg-[#167a83]';
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40" onClick={onCancel} data-testid="confirm-modal">
      <div className="bg-white rounded-xl shadow-xl w-full max-w-sm mx-4 p-6 space-y-4" onClick={e => e.stopPropagation()}>
        <div className="flex items-start gap-3">
          <div className="w-10 h-10 rounded-full bg-amber-50 flex items-center justify-center flex-shrink-0">
            <AlertTriangle className="w-5 h-5 text-amber-500" />
          </div>
          <div>
            <h3 className="text-base font-bold text-slate-800">{title}</h3>
            <p className="text-sm text-slate-500 mt-1">{message}</p>
          </div>
        </div>
        <div className="flex justify-end gap-2 pt-2">
          <button onClick={onCancel} className="px-4 py-2 text-sm text-slate-500 hover:bg-slate-100 rounded-lg" data-testid="confirm-cancel">{cancelLabel}</button>
          <button onClick={onConfirm} className={`px-4 py-2 text-sm text-white rounded-lg ${btnColor}`} data-testid="confirm-accept">{confirmLabel}</button>
        </div>
      </div>
    </div>
  );
}
